import React, { useEffect, useState } from 'react';
import 'firebase/firestore';
import 'firebase/auth';
import { Container, Table, Button, Modal, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import useOrders from '../hooks/useOrders';
import { addOrder, deleteOrder, updateOrder } from '../firebase/firebaseOps';
import { ReactComponent as EditIcon } from '../images/edit.svg';
import { ReactComponent as TrashIcon } from '../images/trash-can.svg';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

const OrderForm = () => {
    const orders = useOrders();
    const [formData, setFormData] = useState({ address: '', dueDate: '', item: '', monto: '', name: '', phone: '' });
    const [showForm, setShowForm] = useState(false);
    const { usuario } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(()=> {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('id');

        if(id){
            console.log(id);
            const order = orders.find(order=>order.id === id);
            if(order){
                handleEdit(order);
            }
        }
    }, [location.search, orders]);

    const closeForm = () => {
        formData.dueDate = new Date(formData.dueDate).getTime() / 1000;
        setShowForm(false);
        setFormData({ address: '', dueDate: '', item: '', monto: '', name: '', phone: '' });

        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('id');
        if(id) {
            navigate('/orders')
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.name && formData.dueDate && formData.phone) {
            if(formData.id){
                updateOrder(formData);
            }else {
                addOrder(formData, usuario.uid);
            }
            setFormData({ address: '', dueDate: '', item: '', monto: '', name: '', phone: '' });
            setShowForm(false);
        } else {
            alert('Todos los campos son obligatorios');
        }
    };

    const deleteEntry = async (id) => {
        try {
            await deleteOrder(id);
        } catch (error) {
            console.error("Error deleting payment", error);
        }
    };

    const handleEdit = (order) => {
        const formattedDueDate = new Date(order.dueDate * 1000).toISOString().split('T')[0];

        order.dueDate = formattedDueDate;
        setFormData(order);
        setShowForm(true);
    }

    return (
        <Container>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Fecha de Entrega</th>
                        <th>Teléfono</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map(order => (
                        <tr key={order.id}>
                            <td>{order.name}</td>
                            <td>{order.displayDate}</td>
                            <td>{order.phone}</td>
                            <td>
                                <EditIcon onClick={() => handleEdit(order)} />
                            </td>
                            <td>
                                <a href='#'><TrashIcon onClick={() => deleteEntry(order.id)} /></a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button variant="primary" onClick={() => setShowForm(true)}>Agregar Pedido</Button>

            <Modal show={showForm} onHide={() => closeForm()}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formName">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control type="text" name="name" value={formData.name} onChange={handleInputChange} required />
                        </Form.Group>
                        <Form.Group controlId="formPhone">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />
                        </Form.Group>
                        <Form.Group controlId="formAddress">
                            <Form.Label>Dirección</Form.Label>
                            <Form.Control as="textarea" name="address" value={formData.address} onChange={handleInputChange} required />
                        </Form.Group>
                        <Form.Group controlId="formDueDate">
                            <Form.Label>Fecha de Entrega</Form.Label>
                            <Form.Control type="date" name="dueDate" value={formData.dueDate} onChange={handleInputChange} required />
                        </Form.Group>
                        <Form.Group controlId="formItem">
                            <Form.Label>Artículo</Form.Label>
                            <Form.Control type="text" name="item" value={formData.item} onChange={handleInputChange} required />
                        </Form.Group>
                        <Form.Group controlId="formMonto">
                            <Form.Label>Monto</Form.Label>
                            <Form.Control type="tel" name="monto" value={formData.monto} onChange={handleInputChange} required />
                        </Form.Group>
                        <Button variant="primary" style={{marginRight: "10px"}} type="submit">Guardar</Button>
                        <Button variant="secondary" onClick={() => closeForm()}>Cancelar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default OrderForm;
